var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbUpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 8.5C0 7.67157 0.67157 7 1.5 7C2.32843 7 3 7.67157 3 8.5V14.5C3 15.3284 2.32843 16 1.5 16C0.67157 16 0 15.3284 0 14.5V8.5Z",
    fill: "#06C067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 8.3333V13.7639C4 14.5215 4.428 15.214 5.10557 15.5528L5.15542 15.5777C5.71084 15.8554 6.32329 16 6.94427 16H12.3604C13.3138 16 14.1346 15.3271 14.3216 14.3922L15.5216 8.3922C15.7691 7.15465 14.8225 6 13.5604 6H10V2C10 0.89543 9.1046 0 8 0C7.44772 0 7 0.44772 7 1V1.66667C7 2.53215 6.71929 3.37428 6.2 4.06667L4.8 5.93333C4.28071 6.62572 4 7.46785 4 8.3333Z",
    fill: "#06C067"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpIcon);
export default __webpack_public_path__ + "static/media/thumbUpIcon.e1db30a3d1b7319542f39daa92297740.svg";
export { ForwardRef as ReactComponent };